import { useState } from "react";
import { Alert } from "react-bootstrap";

interface AlertDismissableProps {
  id:string;
  variant: string;
  label: string;
}
const AlertDismissable = ({
  id,
  variant,
  label
}: AlertDismissableProps) => {
  const [isShown, setIsShown] = useState(true);
  return (
    <>
      {isShown
    && (
      <Alert
        data-testid="alertDismissable"
        key={`alertDismissable_${id}`}
        aria-label={`${variant} - ${label}`}
        variant={variant}
        dismissible
        onClose={() => setIsShown(false)}
      >
        {label}
      </Alert>
    )}
    </>
  );
};

export default AlertDismissable;
